import { db } from "@/firebase/init.js";
import {
  collection,
  query,
  orderBy,
  getDoc,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  updateDoc,
  arrayUnion,
  // Pagination
  limit,
  startAfter,
  //
  where,
} from "firebase/firestore";
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import Swal from "sweetalert2";

const adminsModule = {
  namespaced: true,
  state: {
    adminsList: [],
    adminContent: [],
    updateAdmin: {},
    isLoading: true,
    isFirstLoad: true,
    // Pagination
    loadingMore: false,
    showLoadingButton: true,
    lastVisible: "",
    orderBy: "created_date",
    // Search
    searchResult: [],
    // admin Exams List
    adminExams: [],
    updateAdminExam: {},
  },
  getters: {
    getAdmins: (state) => state.adminsList,
    getAdminContent: (state) => state.adminContent,
    getUpdateAdmin: (state) => state.updateAdmin,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
    // Pagination
    isLoadingMore: (state) => state.loadingMore,
    isShowLoadingButton: (state) => state.showLoadingButton,
    // Search
    getSearchResult: (state) => state.searchResult,
    // admin Exams List
    getAdminExams: (state) => state.adminExams,
    getUpdateAdminExam: (state) => state.updateAdminExam,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Get All admins
    setAdmins: (state, payload) => {
      state.adminsList = payload;
    },

    // Add admin
    addAdmin: (state, payload) => {
      if (state.adminsList.length > 0) state.adminsList.unshift(payload);
      else state.adminsList = [payload];
    },

    // get admin by id
    getSelectAdmin: (state, payload) => {
      state.updateAdmin = payload;
    },

    //
    // Get Search Result
    setSearchResult: (state, payload) => {
      state.searchResult = payload;
    },
    // Update admin
    updateAdmin: (state, payload) => {
      const findIndex = state.adminsList.findIndex(
        (admin) => admin.uid == payload.uid
      );
      state.adminsList[findIndex] = payload;
    },

    // Delete admin
    deleteAdmin: (state, payload) => {
      const findIndex = state.adminsList.findIndex(
        (admin) => admin.uid == payload
      );
      state.adminsList.splice(findIndex, 1);
    },

    //---- Contents

    // Get All admins
    setAdminContent: (state, payload) => {
      state.adminContent = payload;
    },
    // Add admin
    addContent: (state, payload) => {
      if (state.adminContent.length > 0) {
        const item = state.adminContent?.find(
          (e) => e.content_id === payload.content_id
        );
        if (item) return;
        state.adminContent.unshift(payload);
      } else {
        state.adminContent = [payload];
      }
    },

    // Renew Views
    renewView: (state, payload) => {
      const findIndex = state.adminContent.findIndex(
        (content) => content.content_id == payload
      );
      state.adminContent[findIndex].number_of_views = 3;
    },

    // Delete Content in admin
    deleteContent: (state, payload) => {
      const findIndex = state.adminContent.findIndex(
        (content) => content.content_id == payload
      );
      state.adminContent.splice(findIndex, 1);
    },
    //-------------------on Select---------------------
    // Update
    updateAdminsList: (state, payload) => {
      payload.admins.forEach((admin) => {
        const findIndex = state.adminsList.findIndex(
          (stu) => stu.uid == admin.uid
        );
        state.adminsList[findIndex].fullClassesInfo.push(
          ...payload.fullClassesInfo
        );
        state.adminsList[findIndex].classes.push(...payload.classes);
      });
    },

    // Pagination and Sort and Search
    setData: (state, payload) => {
      state.adminsList = payload;
    },
    setLastVisible: (state, payload) => {
      state.lastVisible = payload;
    },
    setOrderBy: (state, payload) => {
      state.orderBy = payload;
    },
    setNextData: (state, payload) => {
      state.adminsList.push(...payload);
    },
    setShowLoadingButton: (state, payload) => {
      state.showLoadingButton = payload;
    },
    setLoadingMore: (state, payload) => {
      state.loadingMore = payload;
    },
    //-------------------------------
    // admin Exams
    // set
    setAdminExams: (state, payload) => {
      state.adminExams = payload;
    },
    setupdateAdminExam: (state, payload) => {
      state.updateAdminExam = payload;
    },
    // Update admin
    setUpdatedAdminExam: (state, payload) => {
      const findIndex = state.adminExams.findIndex(
        (exam) => exam.exam_id == payload.exam_id
      );
      state.adminExams[findIndex] = payload;
    },
    // Delete
    setDeleteAdminExam: (state, payload) => {
      const findIndex = state.adminExams.findIndex(
        (exam) => exam.exam_id == payload
      );
      state.adminExams.splice(findIndex, 1);
    },
  },
  actions: {
    //---- Pagination
    async getFirstData({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);
      const data = await getDocs(query(collection(db, "Admins"), limit(10)));
      const lastVisible = data.docs[data.docs.length - 1] || null;
      commit("setLastVisible", lastVisible);
      let dataArray = [];
      if (!data.empty) {
        data.forEach((doc) => {
          // The doc id is the authoritative admin id — always carry it.
          dataArray.push({ ...doc.data(), uid: doc.id });
        });
      } else {
        dataArray = false;
      }
      if (data.size >= 10) {
        commit("setShowLoadingButton", true);
      } else {
        commit("setShowLoadingButton", false);
      }
      commit("setData", dataArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);
    },

    async getNextData({ commit }) {
      commit("setLoadingMore", true);
      const data = await getDocs(
        query(
          collection(db, "Admins"),
          orderBy(this.state.adminsModule.orderBy),
          limit(10),
          startAfter(this.state.adminsModule.lastVisible)
        )
      );
      const lastVisible = data.docs[data.docs.length - 1] || null;
      commit("setLastVisible", lastVisible);
      let dataArray = [];
      if (!data.empty) {
        data.forEach((doc) => {
          dataArray.push({ ...doc.data(), uid: doc.id });
        });
      }
      commit("setNextData", dataArray);
      if (data.size >= 10) {
        commit("setShowLoadingButton", true);
      } else {
        commit("setShowLoadingButton", false);
      }
      commit("setLoadingMore", false);
    },
    changeSorting({ commit }, payload) {
      commit("setOrderBy", payload);
    },
    // ----- Search
    async searchData({ commit }, payload) {
      commit("setFirstLoad", false);
      console.log(payload);

      const data = await getDocs(
        query(
          collection(db, "Admins"),
          where("firstName", ">=", payload),
          limit(10)
        )
      );
      let dataArray = [];
      data.forEach((doc) => {
        dataArray.push({ code_id: doc.id, ...doc.data() });
      });
      commit("setSearchResult", dataArray);
    },

    // Add admin
    // eslint-disable-next-line no-unused-vars
    async addAdmin({ commit }, payload) {
      const auth = getAuth();
      const adminRegister = await createUserWithEmailAndPassword(
        auth,
        payload.email,
        payload.password
      ).catch((error) => {
        console.log({ error });
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "error",
          title: error.code,
        });
      });

      if (!adminRegister) return;

      const documentReference = doc(
        collection(db, "Admins"),
        adminRegister.user.uid
      );

      const admin = {
        ...payload,
        uid: documentReference.id,
        created_date: new Date(),
        meta: JSON.stringify(adminRegister.user),
        aid: adminRegister.user?.uid,
      };
      await setDoc(documentReference, admin);
      commit("addAdmin", admin);
      return admin;
    },

    // get Studnet by id
    async getAdminById({ commit }, payload) {
      let adminselect = await getDoc(doc(db, "Admins", payload));
      console.log(adminselect.data());
      commit("getSelectAdmin", adminselect.data());
      return adminselect.data();
    },

    // Update admin
    // Throws on failure — the caller must not report success unconditionally.
    async updateAdmin({ commit }, payload) {
      if (!payload?.uid) {
        throw new Error("updateAdmin called without an admin id");
      }
      await updateDoc(doc(db, "Admins", payload.uid), payload);
      commit("updateAdmin", payload);
      return payload;
    },

    // Update ONLY a supervisor's permissions, addressed by document id.
    // Kept separate from updateAdmin so a permissions change can never carry
    // along a stale copy of the rest of the document.
    async updateAdminPermissions({ commit }, { uid, permissions }) {
      if (!uid) {
        throw new Error("updateAdminPermissions called without an admin id");
      }
      const nextPermissions = Array.isArray(permissions) ? [...permissions] : [];
      await updateDoc(doc(db, "Admins", uid), { permissions: nextPermissions });
      commit("updateAdmin", { uid, permissions: nextPermissions });
      return nextPermissions;
    },

    // Delete admin
    async deleteAdmin({ commit }, payload) {
      await deleteDoc(doc(db, "Admins", payload));
      commit("deleteAdmin", payload);
    },

    //----Content
    // Add admin collection to class
    async addContentToAdminsClass({ commit }, payload) {
      // let admins;
      payload.adminIDs.forEach((adminId) => {
        const documentReference = doc(
          db,
          `Admins/${adminId}/codes`,
          payload.code.content_id
        );
        const content = {
          ...payload.code,
          created_date: new Date(),
        };
        setDoc(documentReference, content);
        commit("addContent", content);
      });

      commit("setFirstLoad", false);
    },

    // get Sub Collection Codes
    async getSubCollection({ commit }, payload) {
      commit("setLoading", true);
      let adminContent = [];
      const adminsubContent = await getDocs(
        query(
          collection(db, `Admins/${payload}/codes`),
          orderBy("created_date", "desc")
        )
      );
      if (!adminsubContent.empty) {
        adminsubContent.forEach((doc) => {
          adminContent.push({ ...doc.data() });
        });
      } else {
        console.log("The admin Don't have any Contents");
        adminContent = false;
      }
      commit("setAdminContent", adminContent);
      commit("setLoading", false);
    },

    // get Sub Collection Codes
    async addContentToSudent({ commit }, payload) {
      const documentReference = doc(
        db,
        `Admins/${payload.id}/codes`,
        payload.code.content_id
      );
      const content = {
        ...payload.code,
        created_date: new Date(),
      };
      console.log(content, documentReference, payload);

      setDoc(documentReference, content);
      commit("addContent", content);
    },

    // Renew Views
    renewContentViews({ commit }, payload) {
      updateDoc(doc(db, `Admins/${payload.uid}/codes`, payload.content_id), {
        number_of_views: 3,
        date_of_usage: null,
      });
      commit("renewView", payload.content_id);
    },

    // Delete Sub Collection
    deleteContentFromAdmin({ commit }, payload) {
      deleteDoc(doc(db, `Admins/${payload.uid}/codes`, payload.content_id));
      commit("deleteContent", payload.content_id);
    },

    //--------------------------------
    // On Select
    deleteAdmins({ commit }, payload) {
      payload.forEach((admin) => {
        deleteDoc(doc(collection(db, "Admins"), admin.uid));
        commit("deleteAdmin", admin.uid);
      });
    },

    addClassesToAdmins({ commit }, payload) {
      for (let i = 0; i < payload.admins.length; i++) {
        updateDoc(
          doc(db, `Admins/${payload.admins[i].uid}`),
          {
            classes: arrayUnion(...payload.classes),
            fullClassesInfo: arrayUnion(...payload.fullClassesInfo),
          },
          { merge: true }
        );
      }

      commit("updateAdminsList", payload);
    },

    addClassToAdmins({ commit }, payload) {
      for (let i = 0; i < payload.admins.length; i++) {
        updateDoc(
          doc(db, `Admins/${payload.admins[i]}`),
          {
            classes: arrayUnion(payload.classes),
            fullClassesInfo: arrayUnion(payload.fullClassesInfo),
          },
          { merge: true }
        );
      }

      commit("setFirstLoad", false);
    },

    //---------------------------------
    // Add Exam Degree to admin
    addExamDegreeToAdmin({ commit }, payload) {
      for (let i = 0; i < payload.adminNum; i++) {
        const documentReference = doc(
          collection(db, `Admins/${Object.keys(payload.admins)[i]}/Exams`)
        );
        const exam = {
          degree: Object.values(payload.admins)[i],
          created_date: new Date(),
          exam_id: documentReference.id,
          title: payload.title,
          full_degree: payload.full_degree,
        };
        setDoc(documentReference, exam);
      }
      commit("setFirstLoad", false);
    },
    // Get admin Exams
    async examDegreeFromAdmin({ commit }, payload) {
      commit("setLoading", true);

      const ExamsList = await getDocs(
        query(
          collection(db, `Admins/${payload}/Exams`),
          orderBy("created_date", "desc")
        )
      );
      let adminExams = [];
      if (!ExamsList.empty) {
        ExamsList.forEach((doc) => {
          adminExams.push({
            ...doc.data(),
            exam_id: doc.id,
          });
        });
      }
      console.log(adminExams);
      commit("setAdminExams", adminExams);
      commit("setLoading", false);
    },

    async adminExamById({ commit }, payload) {
      let examSelect = await getDoc(
        doc(db, `Admins/${payload.uid}/Exams`, payload.exam_id)
      );
      commit("setupdateAdminExam", examSelect.data());
      return examSelect.data();
    },

    updateExamDegree({ commit }, payload) {
      updateDoc(
        doc(db, `Admins/${payload.uid}/Exams`, payload.updateAdminExam.exam_id),
        payload.updateAdminExam
      );
      commit("setUpdatedAdminExam", payload.updateAdminExam);
    },

    deleteExamDegree({ commit }, payload) {
      deleteDoc(doc(db, `Admins/${payload.uid}/Exams`, payload.exam_id));
      commit("setDeleteAdminExam", payload.exam_id);
    },
  },
};

export default adminsModule;
